import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';

const useGalleryArtworks = (params) => {
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);

  const _params = {
    ...objectParamsFromSearchParams,
    ...params,
  };

  return useQuery({
    queryKey: [API.ARTWORK.LIST_GALLERY_ARTWORK, _params],
  });
};

export default useGalleryArtworks;
